module.exports = require('./helpers/bundle-url').getBundleURL('glq1z') + "logo.c51670a8.svg";